document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initComparador();
  initMarquesina();
  initGaleriaProducto();
  initCantidadProducto();
  initVariantesProducto();
});

function initGaleriaProducto() {
  var principal = document.getElementById('mt-galeria-img-principal');
  var thumbs = document.querySelectorAll('[data-mt-thumb]');
  if (!principal || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      principal.src = thumb.getAttribute('data-full');
      principal.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (t) { t.classList.remove('mt-galeria-thumb-activa'); });
      thumb.classList.add('mt-galeria-thumb-activa');
    });
  });
}

function initCantidadProducto() {
  var input = document.getElementById('mt-cantidad-input');
  if (!input) return;
  var menos = document.querySelector('[data-mt-cantidad-menos]');
  var mas = document.querySelector('[data-mt-cantidad-mas]');
  if (menos) menos.addEventListener('click', function () {
    var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    input.value = v;
  });
  if (mas) mas.addEventListener('click', function () {
    var v = (parseInt(input.value, 10) || 1) + 1;
    input.value = v;
  });
}

function initVariantesProducto() {
  var json = document.getElementById('mt-variantes-json');
  if (!json) return;
  var variantes = JSON.parse(json.textContent);
  var grupos = document.querySelectorAll('[data-mt-opcion-indice]');
  if (!grupos.length) return;
  var idInput = document.getElementById('mt-variante-id');
  var botonComprar = document.getElementById('mt-boton-comprar');
  var botonTexto = botonComprar ? botonComprar.querySelector('[data-mt-boton-texto]') : null;
  var textoComprar = botonComprar && botonTexto ? botonTexto.textContent : '';
  var precioEl = document.getElementById('mt-precio-actual');
  var precios = {};
  var preciosJson = document.getElementById('mt-precios-json');
  if (preciosJson) {
    try { precios = JSON.parse(preciosJson.textContent); } catch (e) { precios = {}; }
  }

  function seleccionActual() {
    // Coloca cada valor en la posicion real de su opcion (option1/2/3),
    // no en el orden en que aparecen en la pagina.
    var sel = [null, null, null];
    grupos.forEach(function (grupo) {
      var idx = parseInt(grupo.getAttribute('data-mt-opcion-indice'), 10);
      if (isNaN(idx)) return;
      var activo = grupo.querySelector('.mt-opcion-valor-activa');
      sel[idx] = activo ? activo.getAttribute('data-mt-valor') : null;
    });
    return sel;
  }

  function actualizar() {
    var sel = seleccionActual();
    var variante = variantes.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return sel.every(function (val, i) { return val === null || opts[i] === val; });
    });
    if (!variante) return;
    if (idInput) idInput.value = variante.id;
    if (precioEl && precios[variante.id]) precioEl.textContent = precios[variante.id];
    if (botonComprar) {
      botonComprar.disabled = !variante.available;
      if (botonTexto) botonTexto.textContent = variante.available ? textoComprar : (botonComprar.getAttribute('data-agotado-texto') || 'Agotado por ahora');
    }
  }

  grupos.forEach(function (grupo) {
    var valores = grupo.querySelectorAll('[data-mt-valor]');
    valores.forEach(function (valor) {
      valor.addEventListener('click', function () {
        valores.forEach(function (v) { v.classList.remove('mt-opcion-valor-activa'); });
        valor.classList.add('mt-opcion-valor-activa');
        actualizar();
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-fin') || '0');
      var dur = 1200;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / dur, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (fin % 1 === 0) ? Math.round(valor) : valor.toFixed(1);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin % 1 === 0 ? fin : fin.toFixed(1);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  var wraps = document.querySelectorAll('.mt-comparador');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('.mt-comparador-asa');
    var after = wrap.querySelector('.mt-comparador-despues');
    if (!handle || !after) return;
    var dragging = false;

    function set(pct) {
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    function posFromEvent(e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    handle.addEventListener('mousedown', function () { dragging = true; });
    handle.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
    window.addEventListener('mouseup', function () { dragging = false; });
    window.addEventListener('touchend', function () { dragging = false; });
    window.addEventListener('mousemove', function (e) { if (dragging) set(posFromEvent(e)); });
    window.addEventListener('touchmove', function (e) { if (dragging) set(posFromEvent(e)); }, { passive: true });
    wrap.addEventListener('click', function (e) { set(posFromEvent(e)); });

    set(50);
  });
}

function initMarquesina() {
  var tracks = document.querySelectorAll('.mt-marquesina-track');
  tracks.forEach(function (track) {
    if (track.dataset.duplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicado = '1';
  });
}
